export const ErrorTypes = {
  USER_ACTIVELY_EXIST_IN_SUB_MODULE: 'USER_ACTIVELY_EXIST_IN_SUB_MODULE',
};
